import React from 'react';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';
import { AllGalery } from '../../components/galery';

function Galery (){
    return(        
        <body>
        <Navbar/>
        <hr className='hr-min'/>
        <AllGalery/>
        <Footer/>
        </body>
    )
}
export default Galery;